/* Tribune — search.js : fenêtre de recherche + suggestions (Predictive Search API) */
(() => {
  'use strict';
  const routes = (window.theme && window.theme.routes) || {};

  class SearchModal extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('#PredictiveResults');
      this.predictive = this.dataset.predictive === 'true';
      this.cache = {};
      this.onOpenClick = (e) => {
        const opener = e.target.closest('[data-open-search]');
        if (!opener) return;
        e.preventDefault();
        this.open(opener);
      };
      document.addEventListener('click', this.onOpenClick);
      this.addEventListener('click', (e) => { if (e.target.closest('[data-search-close]')) this.close(); });
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      if (this.predictive) {
        let t;
        this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.search(this.input.value.trim()), 250); });
      }
    }
    disconnectedCallback() { document.removeEventListener('click', this.onOpenClick); }
    open(opener) {
      this.opener = opener;
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        document.body.classList.add('is-locked');
        opener && opener.setAttribute('aria-expanded', 'true');
        this.input.focus();
        this.input.select();
      });
    }
    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      if (this.opener) { this.opener.setAttribute('aria-expanded', 'false'); this.opener.focus(); }
      setTimeout(() => { if (!this.classList.contains('is-open')) this.hidden = true; }, 300);
    }
    onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key === 'Tab') {
        const els = Array.from(this.querySelectorAll('a[href], button, input:not([type="hidden"])')).filter((el) => el.offsetParent !== null);
        const first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;
      const options = Array.from(this.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      if (e.key === 'Enter') {
        if (current > -1) { e.preventDefault(); const link = options[current].querySelector('a') || options[current]; link.click(); }
        return;
      }
      e.preventDefault();
      let next = e.key === 'ArrowDown' ? current + 1 : current - 1;
      if (next >= options.length) next = 0;
      if (next < 0) next = options.length - 1;
      options.forEach((o, i) => o.setAttribute('aria-selected', i === next ? 'true' : 'false'));
      this.input.setAttribute('aria-activedescendant', options[next].id);
      options[next].scrollIntoView({ block: 'nearest' });
    }
    search(term) {
      if (!term) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      if (this.cache[term]) { this.render(this.cache[term]); return; }
      this.controller && this.controller.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,page,article,query',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor,tag'
      });
      fetch(`${routes.predictiveSearch}?${params}`, { signal: this.controller.signal })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('#shopify-section-predictive-search');
          const markup = content ? content.innerHTML : '';
          this.cache[term] = markup;
          this.render(markup);
        })
        .catch((err) => { if (err.name !== 'AbortError') this.results.innerHTML = ''; });
    }
    render(markup) {
      this.results.innerHTML = markup;
      this.input.setAttribute('aria-expanded', markup ? 'true' : 'false');
      this.input.removeAttribute('aria-activedescendant');
    }
  }
  if (!customElements.get('search-modal')) customElements.define('search-modal', SearchModal);
})();
